"use client";

import { useEffect, useRef } from "react";

type Item = { href: string; label: string; current: boolean; count?: number; muted?: boolean };

/** Filter als Aufklappliste im Pillen-Stil. Ohne JavaScript per <details>; mit JavaScript schließen Escape und Klick daneben. */
export function FilterDropdown({ label, prefix, items }: { label: string; prefix: string; items: Item[] }) {
  const ref = useRef<HTMLDetailsElement>(null);
  const current = items.find((i) => i.current) ?? items[0];
  const active = !!current && current !== items[0];

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape" || !el.open) return;
      el.open = false;
      el.querySelector("summary")?.focus();
    };
    const onDown = (e: PointerEvent) => {
      if (el.open && !el.contains(e.target as Node)) el.open = false;
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("pointerdown", onDown);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("pointerdown", onDown);
    };
  }, []);

  return (
    <details ref={ref} className="tdrop">
      <summary className={`tdrop-btn${active ? " on" : ""}`}>
        <span className="tdrop-prefix">{prefix}:</span> {current?.label}
        <svg className="tdrop-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
      </summary>
      <nav aria-label={label}>
        <ul className="tdrop-list">
          {items.map((it) => (
            <li key={it.href}>
              <a href={it.href} aria-current={it.current ? "page" : undefined} className={it.muted ? "muted" : undefined}>
                <span>{it.label}</span>
                {it.count != null && <span className="tpill-count">{it.count}</span>}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </details>
  );
}
